import { render, staticRenderFns } from "./HelpdeskStaff.vue?vue&type=template&id=3822881c&scoped=true"
import script from "./HelpdeskStaff.vue?vue&type=script&lang=js"
export * from "./HelpdeskStaff.vue?vue&type=script&lang=js"
import style0 from "./HelpdeskStaff.vue?vue&type=style&index=0&id=3822881c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3822881c",
  null
  
)

export default component.exports